import { useMediaQuery } from '@material-ui/core';
import theme from '../../theme';

const useIsMobile = () =>
  useMediaQuery(theme.breakpoints.down('xs'));

export default useIsMobile;
